import { useState } from 'react';

import { useRecoilValue } from 'recoil';

import { printAgGridTable, printTable } from 'lib/helpers/exportPdf/printPdf';

import { currentPractice } from 'components/practice/practiceState';

import { ExportContext } from './ExportContext';

export const ExportContextProvider = ({ children, category, hasPractice = true }) => {
  const practice = useRecoilValue(currentPractice);

  const [gridApis, setGridApis] = useState({});
  const [headerConfigs, setHeaderConfigs] = useState({});
  const [footerProps, setFooterProps] = useState({});
  const [tableData, setTableData] = useState({});
  const [columns, setColumns] = useState({});

  const onPrint = () => {
    if (gridApis) {
      printAgGridTable({
        hasMultiple: true,
        gridApi: gridApis,
        headerConfigs,
        footerConfigs: footerProps
      });
      return;
    }

    printTable({
      tableData,
      columns,
      headerConfigs,
      footerConfigs: footerProps
    });
  };

  const handleHeaderConfigs = (id, configs) => {
    if (!id) {
      return;
    }

    setHeaderConfigs((prev) => ({
      ...prev,
      [id]: { ...(hasPractice && { practice }), ...configs }
    }));
  };

  const handleFooterProps = (id, configs) => {
    if (!id) {
      return;
    }

    setFooterProps((prev) => ({ ...prev, [id]: { customFooter: category, footerProps: configs } }));
  };

  return (
    <ExportContext.Provider
      value={{
        onPrint,
        setHeaderConfigs: handleHeaderConfigs,
        setGridApi: (id, api) => id && setGridApis((prev) => ({ ...prev, [id]: api })),
        setFooterProps: handleFooterProps,
        setTableData: (id, data) => id && setTableData((prev) => ({ ...prev, [id]: data })),
        setColumns: (id, columns) => id && setColumns((prev) => ({ ...prev, [id]: columns }))
      }}>
      {children}
    </ExportContext.Provider>
  );
};
